import { TruncatedText } from "@/components/ui/truncation-tooltip";
import { uiMessages } from "@/services/messages";

interface FileSheetLabelProps {
	fileName: string;
	/** Лист Excel-книги; пустой — только имя файла. */
	sheetName: string | null | undefined;
	className?: string;
}

/**
 * Подпись «файл · лист» (фича 038). Лист различает строки разных листов
 * одной книги, поэтому имя файла сжимается первым; лист занимает не больше
 * 60% ширины, длиннее — обрезается с подсказкой.
 */
export function FileSheetLabel({ fileName, sheetName, className = "" }: FileSheetLabelProps) {
	if (!sheetName) return <TruncatedText value={fileName} className={className} />;

	return (
		<span className={`flex min-w-0 items-baseline overflow-hidden ${className}`}>
			<TruncatedText value={fileName} className="min-w-0" />
			<span className="shrink-0 whitespace-pre">{uiMessages.file_sheet_separator}</span>
			<TruncatedText value={sheetName} className="min-w-0 max-w-[60%] shrink-0" />
		</span>
	);
}
